import type { GlobalStateMergedState } from 'components/GlobalState/GlobalStateModel';
import { selectLoadedInitialAppData } from 'components/GlobalState/selectors/selectLoadedInitialAppData';

export const selectAppInitialized = (s: GlobalStateMergedState): boolean =>
  selectLoadedInitialAppData(s) &&
  s.license.state !== 'NOT_VERIFIED' &&
  s.loginStatus !== 'UNINITIALIZED' &&
  s.socketState !== 'UNINITIALIZED';
